import { Pipe, PipeTransform } from '@angular/core';
import { Address } from '../../models/address';

@Pipe({
  name: 'addressType',
})
export class AddressTypePipe implements PipeTransform {
  /**
   * filters addresses by type.
   */
  transform(value: Address[], type: string) {
    if (value) {
      return value.filter(x => x.type.name == type);
    }
  }
}


// WEBPACK FOOTER //
// ./src/pipes/address-type/address-type.ts